export const PROJECT_NAME = 'typings'
export const PRETTY_PROJECT_NAME = 'Typings'
export const CONFIG_FILE = `${PROJECT_NAME}.json`
export const DEFAULT_TYPINGS_DIR = PROJECT_NAME

export const HOMEPAGE = 'https://github.com/typings/typings'
export const ISSUES_HOMEPAGE = 'https://github.com/typings/typings/issues'

export const DEPENDENCY_SEPARATOR = '~'

export const REGISTRY_URL = 'https://api.typings.org'
